<template>
  <div>
    <!-- Header moved outside the card -->
    <div class="recommendations-header">
      <div class="title">Latest Recommendations</div>
      <span
        class="view-all"
        @click="$router.push('/experts-past-recommendations')"
      >
        View all ({{ recommendations ? recommendations.length : 0 }})
      </span>
    </div>

    <!-- Card with recommended stocks -->
    <div
      v-if="recommendations && recommendations.length > 0" 
      class="recommended-stocks-container"
    >
      <!-- Blur overlay for Lite plan -->
      <div v-if="isLitePlan" class="blur-overlay">
        <div class="lock-message">
          <img src="../assets/images/Lock.svg" alt="lock" class="lock-icon" />
          <div class="subscribe-row">
            <button
              class="subscribe-btn btn-secondary-theme-filled"
              @click.stop="$router.push('/pricing')"
            >
              Subscribe
            </button>
            <img
              style="width:25px; height:25px; cursor: pointer;"
              src="../assets/images/Youtube Icon.png"
              alt="YouTube"
              @click="videoDialog = true"
            />
          </div>

          <div class="features-list">
            <div>
              <i class="el-icon-check"></i>
              Bundle of SEBI Research Analyst
            </div>
            <div>
              <i class="el-icon-check"></i>
              15+ Daily Strategies
            </div>
            <div>
              <i class="el-icon-check"></i>
              Price estimate tracking of Advisory
            </div>
          </div>
        </div>
      </div>

      <div class="recommended-stocks">
        <div
          v-for="(stock, index) in latestThreeRecommendations"
          :key="stock.id"
          class="stock-item"
          @click="openStockPopup(stock, 'recoPopup')"
        >
          <div class="stock-left">
            <img :src="stock.stock_logo" class="stock-logo" />
            <div class="stock-details">
              <p class="stock-name">{{ stock.stock_name }}</p>
              <p class="remaining-target">Remaining Target</p>
              <p class="percentage">{{ stock.remaining_potential }}%</p>
            </div>
          </div>

          <div class="stock-right">
            <div class="timestamp-logo">
              <p class="timestamp">{{ formatTimestamp(stock.created_at) }}</p>
              <el-tooltip effect="dark" placement="top">
                <template #content>
                  <div>
                    <strong v-if="stock.user_detail">
                      {{ stock.user_detail.name }}
                    </strong>
                    <br />
                    SEBI Reg:
                    <span v-if="stock.user_detail">
                      {{ stock.user_detail.sebi_regi_number }}
                    </span>
                  </div>
                </template>
                <div class="expert-logo">
                  <img
                    v-if="stock.user_detail && stock.user_detail.profile_pic"
                    :src="
                      serverHostName + '/Media/' + stock.user_detail.profile_pic
                    "
                    alt="profile"
                  />
                  <img
                    v-else
                    src="../assets/images/navBar/avatar.jpg"
                    alt="profile"
                  />
                </div>
              </el-tooltip>
            </div>

            <div class="action-buttons">
              <div>
                <button
                  class="buy-sell"
                  :style="{ backgroundColor: getButtonColor(stock.reco) }"
                  @click.stop="openStockPopup(stock, 'trade')"
                  v-if="
                    userProfile &&
                      !currentEnvironment.byPassLogin &&
                      !currentEnvironment.isStockAntsAuth &&
                      userProfile.utm_source !== 'Fyers' &&
                      userProfile.utm_source !== 'BlinkX' &&
                      userProfile.utm_source !== 'AngelOne' &&
                      userProfile.utm_source !== '5 Paisa' &&
                      userProfile.utm_source !== 'Dhan' &&
                      userProfile.utm_source !== 'Finvasia' &&
                      userProfile.utm_source !== 'Zerodha'
                  "
                >
                  {{ stock.reco }}
                </button>

                <button
                  v-else-if="
                    currentEnvironment.byPassLogin &&
                      currentEnvironment.isHybridModel
                  "
                  class="buy-sell"
                  :style="{ backgroundColor: getButtonColor(stock.reco) }"
                  @click.stop="getTradeHostDetails"
                >
                  {{ stock.reco }}
                </button>

                <button
                  v-else
                  class="buy-sell"
                  :style="{ backgroundColor: getButtonColor(stock.reco) }"
                  style="cursor: not-allowed"
                >
                  {{ stock.reco }}
                </button>
              </div>
              <!-- <img src="../assets/images/bookmark (3).svg" alt="Arrow Icon" class="watchlist-icon cursor-pointer" @click.stop="followReco(stock.id, index, 'FOLLOW')" v-if="!stock.is_reco_subscribe_for_notification" />
              <img src="../assets/images/Filled bookmark.svg" alt="Arrow Icon" class="watchlist-icon cursor-pointer" @click.stop="followReco(stock.id, index, 'UNFOLLOW')" v-else /> -->
            </div>
          </div>

          <hr v-if="index < recommendations.length - 1" class="divider" />
        </div>
      </div>
    </div>

     <!-- Youtube video dialog -->
     <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <div class="iframe-container">
          <iframe id="videoId" width="100%" height="600px"
            src="https://www.youtube.com/embed/umwESJwcelY" title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { serverHostName } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';
import moment from 'moment';

export default {
  props: ['recommendations', 'isRecoListLoading'],
  name: 'CommunityLatestRecommendations',

  components: {
    NoDataFound
  },
  data() {
    return {
      isApiLoading: false,
      serverHostName: serverHostName,
      currentEnvironment: {},
      videoDialog: false,
    };
  },
  mounted() {
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(
        localStorage.getItem('currentEnvironment')
      );
      this.hostUrl = this.currentEnvironment.hostUrl;
    }
  },
  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
    latestThreeRecommendations() {
      return this.recommendations ? this.recommendations.slice(0, 3) : [];
    },
    isLitePlan() {
      const planDetails = JSON.parse(localStorage.getItem('plan_details'));
      return planDetails && planDetails.plan === 'Lite';
    }
  },
  methods: {
    openStockPopup(reco, action) {
      this.$emit('get_reco_details', reco, action);
    },
    getTradeHostDetails() {
      this.$store.commit('commitHybridBrokerLoginDialogVisibility', true);
    },
    formatTimestamp(timestamp) {
      return moment(timestamp).format('MMM DD, YYYY, h:mm A');
    },
    getButtonColor(reco) {
      return reco === 'Buy'
        ? '#0BA042'
        : reco === 'Sell'
        ? '#EA2526'
        : '#ffc107';
    }, 

    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById("videoId");
      let url = video.getAttribute("src");
      video.setAttribute("src", "");
      video.setAttribute("src", url);
    },
  }
};
</script>

<style scoped lang="scss">
.recommendations-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0 10px;
  padding: 0 10px;

  .title {
    font-size: 15px;
    font-weight: 600;
  }

  .view-all {
    font-size: 14px;
    font-weight: 500;
    color: #2d2e8d;
    cursor: pointer;

    &:hover {
      color: #0e4bf1;
    }
  }
}

.recommended-stocks-container {
  position: relative;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  .blur-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 64%;
    backdrop-filter: blur(4px);
    background: rgba(255, 255, 255, 0.6);
    z-index: 2;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 100px;

    .lock-message {
      text-align: center;
      color: #000;

      .lock-icon {
        width: 25px;
        // margin-bottom: 10px;
      }
    }

    .subscribe-row {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      margin-top: 10px;

      .youtube-logo {
        width: 30px;
        cursor: pointer;
      }

      .subscribe-btn {
        width: 200px;
        border-radius: 10px;
        background: #2d2e8d;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
        font-size: 13px;
        font-weight: 500;
        line-height: normal;
        text-transform: capitalize;
        cursor: pointer;
      }
    }

    .features-list {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      color: #2d2e8d;

      div {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-bottom: 5px;
        font-size: 12px;
        font-weight: 600;

        i {
          color: #000000;
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  .recommended-stocks {
    position: relative;
    z-index: 1;

    .divider {
      border: none;
      border-top: 1px solid #ddd;
      margin: 5px 0;
    }

    .stock-item {
      display: flex;
      align-items: flex-start;
      background-color: #ffffff;
      cursor: pointer;
      border-bottom: 2px solid #f0f0f0;
      padding: 10px 0px;

      .stock-left {
        display: flex;
        align-items: flex-start;
        gap: 15px;

        .stock-logo {
          width: 35px;
          height: 35px;
          border-radius: 50%;
        }

        .stock-details {
          display: flex;
          flex-direction: column;

          .stock-name {
            font-size: 13px;
            font-weight: 600;
            margin: 0px;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 170px;
          }

          .remaining-target {
            font-size: 10px;
            font-weight: 500;
            color: #878787;
            margin: 5px 0;
          }

          .percentage {
            font-size: 15px;
            font-weight: 600;
            color: #0ba042;
            margin: 0px 0px 5px 0px;
          }
        }
      }

      .stock-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-left: auto;

        .timestamp-logo {
          display: flex;
          align-items: center;

          .timestamp {
            font-size: 10px;
            font-weight: 500;
            color: #878787;
            margin-right: 10px;
          }

          .expert-logo {
            img {
              width: 25px;
              height: 25px;
              border-radius: 50%;
            }
          }
        }

        .action-buttons {
          display: flex;
          align-items: center;
          gap: 10px;

          .buy-sell {
            padding: 5px 12px;
            width: 55px;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            cursor: pointer;
          }

          .watchlist-icon {
            width: 25px;
            height: 25px;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .recommended-stocks-container {
    .stock-item {
      .stock-left {
        .stock-logo {
          width: 30px;
          height: 30px;
        }

        .stock-details {
          .stock-name {
            font-size: 11px;
            max-width: 120px;
          }

          .remaining-target {
            font-size: 10px;
          }

          .percentage {
            font-size: 13px;
          }
        }
      }

      .stock-right {
        .timestamp-logo {
          .timestamp {
            font-size: 9px;
          }

          .expert-logo {
            img {
              width: 25px;
              height: 25px;
            }
          }
        }

        .action-buttons {
          .buy-sell {
            padding: 5px 15px;
            font-size: 10px;
          }

          .watchlist-icon {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}
</style>
